import { text, storeUrl } from '@theme/lb-ui';
(() => {
  const KEY = 'littlebees:wishlist:v1';
  const read = () => {
    try {
      const value = JSON.parse(localStorage.getItem(KEY) || '[]');
      return Array.isArray(value) ? [...new Set(value.filter((item) => typeof item === 'string' && item.length))] : [];
    } catch (_) {
      return [];
    }
  };
  const write = (items) => {
    try {
      localStorage.setItem(KEY, JSON.stringify(items));
    } catch (_) {
      // Keep controls usable when browser storage is unavailable.
    }
    sync();
  };
  const sync = () => {
    const items = read();
    document.querySelectorAll('[data-wishlist-count]').forEach((count) => {
      count.textContent = items.length ? String(items.length) : '';
      count.setAttribute('aria-label', text('saved_items', {count:items.length}));
    });
    document.querySelectorAll('[data-wishlist-toggle]').forEach((button) => {
      const saved = items.includes(button.dataset.productHandle);
      button.setAttribute('aria-pressed', String(saved));
      const title = button.dataset.productTitle || 'this product';
      button.setAttribute('aria-label', text(saved ? 'wish_remove' : 'wish_add', {title}));
      button.title = text(saved ? 'wish_remove' : 'wish_add', {title});
    });
    const list = document.querySelector('[data-wishlist-items]');
    if (list) renderList(list, items);
  };
  let renderId = 0;
  const renderList = async (list, handles) => {
    const current = ++renderId;
    list.replaceChildren();
    if (!handles.length) {
      const empty = document.createElement('p');
      empty.className = 'vjk-wishlist__empty';
      empty.textContent = text('empty_wishlist');
      const link = document.createElement('a');
      link.href = list.dataset.root || storeUrl('');
      link.textContent = text('explore');
      list.append(empty, link);
      return;
    }
    const grid = document.createElement('div');
    grid.className = 'vjk-wishlist__grid';
    list.append(grid);
    const root = list.dataset.root || storeUrl('');
    const gone = (handle) => ({ handle, title: handle.replace(/-/g, ' '), unavailable: true });
    const products = await Promise.all(handles.map(async (handle) => {
      try {
        const response = await fetch(root + 'products/' + encodeURIComponent(handle) + '.js', { headers: { Accept: 'application/json' } });
        if (!response.ok) return gone(handle);
        return await response.json();
      } catch (_) {
        return gone(handle);
      }
    }));
    if (current !== renderId || !list.isConnected) return;
    products.forEach((product, index) => {
      const handle = handles[index];
      const card = document.createElement('article');
      card.className = 'vjk-wishlist__card';
      if (product.unavailable) card.classList.add('vjk-wishlist__card--gone');
      const image = product.featured_image || (Array.isArray(product.images) ? product.images[0] : '');
      if (image) {
        const link = document.createElement('a');
        link.href = root + 'products/' + encodeURIComponent(handle);
        const img = document.createElement('img');
        img.src = image;
        img.alt = product.title || handle;
        img.loading = 'lazy';
        link.append(img);
        card.append(link);
      }
      const title = document.createElement(product.unavailable ? 'span' : 'a');
      title.className = 'vjk-wishlist__title';
      if (!product.unavailable) title.href = root + 'products/' + encodeURIComponent(handle);
      title.textContent = product.title || handle;
      const remove = document.createElement('button');
      remove.type = 'button';
      remove.className = 'vjk-wishlist__remove';
      remove.textContent = text('remove');
      remove.setAttribute('aria-label', text('wish_remove', {title:product.title || handle}));
      remove.addEventListener('click', () => write(read().filter((item) => item !== handle)));
      card.append(title);
      if (product.unavailable) {
        const note = document.createElement('p');
        note.className = 'vjk-wishlist__note';
        note.textContent = text('unavailable');
        card.append(note);
      }
      card.append(remove);
      if (product.price) {
        const price = document.createElement('p');
        price.className = 'vjk-wishlist__price';
        price.textContent = new Intl.NumberFormat(undefined, { style: 'currency', currency: window.Shopify?.currency?.active || 'INR' }).format(product.price / 100);
        card.append(price);
      }
      grid.append(card);
    });
  };
  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-wishlist-toggle]');
    if (!button) return;
    const handle = button.dataset.productHandle;
    if (!handle) return;
    const items = read();
    write(items.includes(handle) ? items.filter((item) => item !== handle) : [...items, handle]);
  });
  window.addEventListener('storage', (event) => {
    if (event.key === KEY) sync();
  });
  document.addEventListener('lb:components:ready', sync);
  document.addEventListener('shopify:section:load', sync);
  sync();
})();